import ServiceReportDiagnosticFromContainer from "@/modules/dwelling/containers/ServiceReportDiagnosticFromContainer.tsx";

import * as OrderRoute from ".";
import OrderContainer from "../containers/OrderContainer";

export const OrderRoutes = [
  {
    key: "order",
    exact: true,
    path: OrderRoute.ORDER,
    component: OrderContainer,
  },
  {
    key: "order-diagnostic-edit",
    exact: true,
    path: OrderRoute.ORDER_DIAGNOSTIC_EDIT,
    component: ServiceReportDiagnosticFromContainer,
  },
];
